var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#979D9E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 8C8.75 8.42188 8.39844 8.75 8 8.75C7.57812 8.75 7.25 8.42188 7.25 8V2.75C7.25 2.35156 7.57812 2 8 2C8.39844 2 8.75 2.35156 8.75 2.75V8ZM3.875 8C3.875 10.2969 5.70312 12.125 8 12.125C10.2734 12.125 12.125 10.2969 12.125 8C12.125 6.73438 11.5391 5.58594 10.625 4.83594C10.2969 4.57812 10.2734 4.10938 10.5312 3.78125C10.7891 3.45312 11.2578 3.42969 11.5859 3.6875C12.8281 4.71875 13.625 6.26562 13.625 8C13.625 11.1172 11.0938 13.625 8 13.625C4.88281 13.625 2.375 11.1172 2.375 8C2.375 6.26562 3.14844 4.71875 4.39062 3.6875C4.71875 3.42969 5.1875 3.45312 5.44531 3.78125C5.70312 4.10938 5.67969 4.57812 5.35156 4.83594C4.4375 5.58594 3.875 6.73438 3.875 8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDisable);
export default __webpack_public_path__ + "static/media/iconDisable.0df29372ba506daf34b0b716e6b3baa0.svg";
export { ForwardRef as ReactComponent };